import { render, staticRenderFns } from "./vcFooter.vue?vue&type=template&id=4ac1049a&scoped=true&"
import script from "./vcFooter.vue?vue&type=script&lang=js&"
export * from "./vcFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac1049a",
  null
  
)

export default component.exports